//router.scrollBehavior.js
import { getMatchedComponents, setScrollRestoration } from './utils'
if (process.client) {
  if ('scrollRestoration' in window.history) {
    setScrollRestoration('manual')
// reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      setScrollRestoration('auto')
    })
// Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      setScrollRestoration('manual')
    })
  }
}

export default function (to, from, savedPosition) {
  // If the returned position is falsy or an empty object, will retain current scroll position
  let position = false
  const isRouteChanged = to !== from
const nuxt = window.$nuxt
// savedPosition is only available for popstate navigations (back button)
  const metaScrollPos = nuxt.context.route.meta[0]?.scrollPos
  if (savedPosition || metaScrollPos) {
    position = metaScrollPos
  }

  // triggerScroll is only fired when a new component is loaded
  if (to.path === from.path && to.hash !== from.hash) {
    nuxt.$nextTick(() => nuxt.$emit('triggerScroll'))
  }

  return new Promise((resolve) => {
    nuxt.$once('triggerScroll', () => {
      const wrapper = document.getElementById('content-wrapper-' + to.name);
      if (wrapper && position && position.y) {
        wrapper.scrollTop = position.y
      }
    })
  })
}
